import React from 'react'
import NewsList from "./NewsList"

const NewsHome = ({ match }) => {
	// La prop match est optionnelle et n'est plus utilisée
	// Le composant s'affiche toujours

	return (
		<section
			className="news-home"
			role="region"
			aria-label="Actualités de la page d'accueil"
			aria-describedby="news-home-description"
		>
			<div id="news-home-description" className="visually-hidden">
				Section des actualités principales affichées sur la page d'accueil
			</div>
			<NewsList where="home" />
		</section>
	)
}

export default NewsHome
